import { Box, Container } from "@mui/material";
import React, { useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Explore from "../layout/explore";
import Header from "../layout/header/Header";
import NoMatch from "../layout/noMatch/noMatch";
import Sidebar from "../layout/sidebar/Sidebar";
import AccountFactory from "../pages/accountFactory";
import Accounts from "../pages/accounts";
import AutomationAssessment from "../pages/assessment";
import CreateAssessment from "../pages/assessment/assessment";
import MigrateAsCode from "../pages/migrateAsCode";
import Provision from "../pages/provision";
import ManageProvision from "../pages/provision/manageProvision";
import Users from "../pages/users";
import Home from "../pages/home";

const AppRouters = () => {
  const [open, setOpen] = useState(false);

  return (
    <Box display="flex">
      <Header open={open} />
      <Sidebar open={open} setOpen={setOpen} />
      <Container
        maxWidth={false}
        sx={{
          overflow: "hidden",
          marginTop: (theme) => theme.spacing(6.5),
          marginLeft: (theme) => theme.spacing(8),
          padding: (theme) => theme.spacing(3, `64px !important`),
        }}
      >
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/explore" />} />
          <Route path="/explore" component={Explore} />
          <Route path="/home" component={Home} />
          <Route path="/accounts" component={Accounts} />
          <Route exact path="/provision" component={Provision} />
          <Route path="/provision/new" component={ManageProvision} />
          <Route path="/provision/edit" component={ManageProvision} />
          <Route path="/provision/clone" component={ManageProvision} />
          <Route
            path="/automation-assessment"
            component={AutomationAssessment}
          />
          <Route path="/assessment-creation" component={CreateAssessment} />
          <Route exact path="/account-factory" component={AccountFactory} />
          <Route path="/users" component={Users} />
          <Route path="/import" component={MigrateAsCode} />
          <Route path="*" component={NoMatch} />
        </Switch>
      </Container>
    </Box>
  );
};

export default AppRouters;
